import {
  dynamicCollectionRendererKey,
  dynamicElementsButtonKey,
  dynamicElementsIconKey,
  dynamicElementsSimpleTextKey,
} from '@epicuro-next/constants/dynamic-elements';
import {
  LIST_ACCESS_PROVIDER_KEY,
  OPENED_LIST_DATA_PROVIDER_KEY,
} from '@epicuro-next/data-providers/providers-registry';
import {
  IDynamicItem,
  LogicOperator,
  Operation,
} from '@epicuro-next/models/platform/dynamic-elements/dynamic-elements';

import {
  isListDetailTab,
  isListNotAllowedForEdit,
  isNormalList,
  isPowerList,
} from '../if-statements/if-statements';

// tslint:disable:no-duplicate-string

const shopTheListLoadingIf: Operation = [
  LogicOperator.EQ,
  [
    {
      provider: OPENED_LIST_DATA_PROVIDER_KEY,
      property: 'shopTheListLoading',
    },
    true,
  ],
];

const shopTheListNotLoadingIf: Operation = [
  LogicOperator.EQ,
  [
    {
      provider: OPENED_LIST_DATA_PROVIDER_KEY,
      property: 'shopTheListLoading',
    },
    false,
  ],
];

const shopTheListContent: IDynamicItem = {
  contentTypeId: dynamicCollectionRendererKey,
  styles: {
    classes: ['arrows-animation'],
  },
  inputs: {
    items: [
      {
        contentTypeId: dynamicElementsSimpleTextKey,
        inputs: {
          text: '@@shopTheListButton',
        },
      },
      {
        contentTypeId: dynamicElementsIconKey,
        styles: {
          classes: ['ml-2'],
        },
        inputs: {
          icon: ['fas', 'angle-right'],
        },
      },
      {
        contentTypeId: dynamicElementsIconKey,
        inputs: {
          icon: ['fas', 'angle-right'],
        },
      },
      {
        contentTypeId: dynamicElementsIconKey,
        inputs: {
          icon: ['fas', 'angle-right'],
        },
      },
    ],
  },
};

export const shopTheListButtonItem: IDynamicItem = {
  contentTypeId: dynamicCollectionRendererKey,
  styles: {
    classes: ['p-2', 'p-md-0', 'd-sm-sticky-bottom'],
  },
  if: [
    LogicOperator.OR,
    [
      isNormalList,
      // show shop the list for power list only for consumers, as owners has Preview button in that place
      [
        LogicOperator.AND,
        [isPowerList, isListDetailTab, isListNotAllowedForEdit],
      ],
    ],
  ],
  inputs: {
    items: [
      {
        contentTypeId: dynamicElementsButtonKey,
        inputs: {
          disabled: {
            provider: LIST_ACCESS_PROVIDER_KEY,
            property: 'shopTheListDisabled',
          },
          action: 'shop-the-list',
        },
        styles: {
          classes: [
            'btn-primary',
            'ml-md-2',
            'd-inline-flex',
            'flex-grow-1',
            'align-items-center',
            'justify-content-center',
          ],
          style: {
            'min-width': '10rem',
          },
        },
        children: [
          {
            ...shopTheListContent,
            if: shopTheListNotLoadingIf,
          },
          {
            contentTypeId: dynamicElementsSimpleTextKey,
            inputs: {
              text: '@@shopTheListButtonLoading',
            },
            if: shopTheListLoadingIf,
          },
        ],
      },
    ],
  },
};
